import { render } from "./My.vue?vue&type=template&id=1418da0c&scoped=true"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"

import "./My.vue?vue&type=style&index=0&id=1418da0c&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1418da0c"]])

export default __exports__